import { DAY_NAME, DAY_SHORT, toggleDay, WEEK_ORDER } from '../lib/offer-days';

type OfferDayPickerProps = {
  days: readonly number[];
  onChange: (days: number[]) => void;
};

/** Which days an oferta applies, Monday first; nothing marked means every day. */
export function OfferDayPicker({ days, onChange }: OfferDayPickerProps) {
  return (
    <div className="field span-2">
      <p className="field-label" id="offer-days-label">Días</p>
      <div className="chip-row offer-days" role="group" aria-label="Días de la oferta">
        {WEEK_ORDER.map((day) => {
          const picked = days.includes(day);
          return (
            <button
              key={day}
              type="button"
              className="chip"
              aria-pressed={picked}
              aria-label={DAY_NAME[day]}
              data-status={picked ? 'active' : undefined}
              onClick={() => onChange(toggleDay(days, day))}
            >
              {DAY_SHORT[day]}
            </button>
          );
        })}
      </div>
      <p className="field-help">Sin días marcados, vale todos los días.</p>
    </div>
  );
}
